import * as React from "react";

import { cn } from "lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const inputVariants = cva(
  // Base appearance
  "flex w-full rounded-xl border bg-white px-4 text-base text-slate-900 placeholder:text-slate-500 transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-white dark:text-slate-900 dark:placeholder:text-slate-500",
  {
    variants: {
      inputSize: {
        sm: "h-10",
        md: "h-12",
        lg: "h-14",
      },
      error: {
        true: "border-appRed focus-visible:ring-0",
        false:
          "border-black focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ring-offset-background",
      },
    },
    defaultVariants: {
      inputSize: "lg",
      error: false,
    },
  }
);

type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, inputSize, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ error, inputSize }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
